export const organizationSizeOptions = [
    { value: "1-10", label: "1-10" },
    { value: "11-50", label: "11-50" },
    { value: "51-200", label: "51-200" },
    { value: "201-1000", label: "201-1000" },
    { value: "1000+", label: "1000+" }
];

  export const currencyOptions = [
    { value: "USD", label: "currency_usd" },
    { value: "EUR", label: "currency_eur" },
    { value: "GBP", label: "currency_gbp" },
    { value: "SAR", label: "currency_sar" },
    // { value: "JPY", label: "currency_jpy" },
    // { value: "AUD", label: "currency_aud" },
    // { value: "CAD", label: "currency_cad" },
    // { value: "CHF", label: "currency_chf" },
    // { value: "CNY", label: "currency_cny" },
    // { value: "SEK", label: "currency_sek" },
    // { value: "NZD", label: "currency_nzd" },
    // { value: "MXN", label: "currency_mxn" },
    // { value: "SGD", label: "currency_sgd" },
    // { value: "HKD", label: "currency_hkd" },
    // { value: "NOK", label: "currency_nok" },
    // { value: "KRW", label: "currency_krw" },
    // { value: "TRY", label: "currency_try" },
    // { value: "RUB", label: "currency_rub" },
    // { value: "INR", label: "currency_inr" },
    // { value: "BRL", label: "currency_brl" },
    // { value: "ZAR", label: "currency_zar" },
    // { value: "AED", label: "currency_aed" },
    // { value: "EGP", label: "currency_egp" }
];

export const countryOptions = [
    { value: "US", label: "country_us" },
    { value: "GB", label: "country_gb" },
    { value: "CA", label: "country_ca" },
    { value: "AU", label: "country_au" },
    { value: "DE", label: "country_de" },
    { value: "FR", label: "country_fr" },
    { value: "IT", label: "country_it" },
    { value: "ES", label: "country_es" },
    { value: "IN", label: "country_in" },
    { value: "CN", label: "country_cn" },
    { value: "JP", label: "country_jp" },
    { value: "BR", label: "country_br" },
    { value: "RU", label: "country_ru" },
    { value: "SA", label: "country_sa" },
    { value: "AE", label: "country_ae" },
    { value: "EG", label: "country_eg" },
    { value: "ZA", label: "country_za" },
    { value: "MX", label: "country_mx" },
    { value: "KR", label: "country_kr" },
    { value: "TR", label: "country_tr" },
    { value: "ID", label: "country_id" },
    { value: "NL", label: "country_nl" },
    { value: "SE", label: "country_se" },
    { value: "CH", label: "country_ch" },
    { value: "PL", label: "country_pl" },
    { value: "BE", label: "country_be" },
    { value: "AT", label: "country_at" },
    { value: "GR", label: "country_gr" },
    { value: "PT", label: "country_pt" },
    { value: "IE", label: "country_ie" },
    { value: "FI", label: "country_fi" },
    { value: "NO", label: "country_no" },
    { value: "DK", label: "country_dk" },
    { value: "CZ", label: "country_cz" },
    { value: "HU", label: "country_hu" },
    { value: "IL", label: "country_il" },
    { value: "SG", label: "country_sg" },
    { value: "NZ", label: "country_nz" },
    { value: "TH", label: "country_th" },
    { value: "MY", label: "country_my" },
    { value: "VN", label: "country_vn" },
    { value: "PH", label: "country_ph" },
    { value: "PK", label: "country_pk" }
];

export const countryTimezones = {
  "US": [
    { value: "America/New_York", label: "timezone_us_eastern" },
    { value: "America/Chicago", label: "timezone_us_central" },
    { value: "America/Denver", label: "timezone_us_mountain" },
    { value: "America/Los_Angeles", label: "timezone_us_pacific" },
    { value: "America/Phoenix", label: "timezone_us_mountain_no_dst" },
    { value: "America/Anchorage", label: "timezone_us_alaska" },
    { value: "Pacific/Honolulu", label: "timezone_us_hawaii" }
  ],
  "GB": [
    { value: "Europe/London", label: "timezone_gb_london" }
  ],
  "CA": [
    { value: "America/Toronto", label: "timezone_ca_eastern" },
    { value: "America/Vancouver", label: "timezone_ca_pacific" },
    { value: "America/Edmonton", label: "timezone_ca_mountain" },
    { value: "America/Winnipeg", label: "timezone_ca_central" },
    { value: "America/Halifax", label: "timezone_ca_atlantic" },
    { value: "America/St_Johns", label: "timezone_ca_newfoundland" }
  ],
  "AU": [
    { value: "Australia/Sydney", label: "timezone_au_sydney" },
    { value: "Australia/Melbourne", label: "timezone_au_melbourne" },
    { value: "Australia/Brisbane", label: "timezone_au_brisbane" },
    { value: "Australia/Adelaide", label: "timezone_au_adelaide" },
    { value: "Australia/Perth", label: "timezone_au_perth" },
    { value: "Australia/Darwin", label: "timezone_au_darwin" },
    { value: "Australia/Hobart", label: "timezone_au_hobart" }
  ],
  "DE": [
    { value: "Europe/Berlin", label: "timezone_de_berlin" }
  ],
  "FR": [
    { value: "Europe/Paris", label: "timezone_fr_paris" }
  ],
  "IT": [
    { value: "Europe/Rome", label: "timezone_it_rome" }
  ],
  "ES": [
    { value: "Europe/Madrid", label: "timezone_es_madrid" },
    { value: "Atlantic/Canary", label: "timezone_es_canary" }
  ],
  "IN": [
    { value: "Asia/Kolkata", label: "timezone_in_kolkata" }
  ],
  "CN": [
    { value: "Asia/Shanghai", label: "timezone_cn_shanghai" }
  ],
  "JP": [
    { value: "Asia/Tokyo", label: "timezone_jp_tokyo" }
  ],
  "BR": [
    { value: "America/Sao_Paulo", label: "timezone_br_sao_paulo" },
    { value: "America/Manaus", label: "timezone_br_manaus" },
    { value: "America/Noronha", label: "timezone_br_noronha" }
  ],
  "RU": [
    { value: "Europe/Moscow", label: "timezone_ru_moscow" },
    { value: "Asia/Yekaterinburg", label: "timezone_ru_yekaterinburg" },
    { value: "Asia/Omsk", label: "timezone_ru_omsk" },
    { value: "Asia/Krasnoyarsk", label: "timezone_ru_krasnoyarsk" },
    { value: "Asia/Irkutsk", label: "timezone_ru_irkutsk" },
    { value: "Asia/Yakutsk", label: "timezone_ru_yakutsk" },
    { value: "Asia/Vladivostok", label: "timezone_ru_vladivostok" },
    { value: "Asia/Magadan", label: "timezone_ru_magadan" },
    { value: "Asia/Kamchatka", label: "timezone_ru_kamchatka" }
  ],
  "SA": [
    { value: "Asia/Riyadh", label: "timezone_sa_riyadh" }
  ],
  "AE": [
    { value: "Asia/Dubai", label: "timezone_ae_dubai" }
  ],
  "EG": [
    { value: "Africa/Cairo", label: "timezone_eg_cairo" }
  ],
  "ZA": [
    { value: "Africa/Johannesburg", label: "timezone_za_johannesburg" }
  ],
  "MX": [
    { value: "America/Mexico_City", label: "timezone_mx_central" },
    { value: "America/Chihuahua", label: "timezone_mx_mountain" },
    { value: "America/Tijuana", label: "timezone_mx_pacific" }
  ],
  "KR": [
    { value: "Asia/Seoul", label: "timezone_kr_seoul" }
  ],
  "TR": [
    { value: "Europe/Istanbul", label: "timezone_tr_istanbul" }
  ],
  "ID": [
    { value: "Asia/Jakarta", label: "timezone_id_jakarta" },
    { value: "Asia/Makassar", label: "timezone_id_makassar" },
    { value: "Asia/Jayapura", label: "timezone_id_jayapura" }
  ],
  "NL": [
    { value: "Europe/Amsterdam", label: "timezone_nl_amsterdam" }
  ],
  "SE": [
    { value: "Europe/Stockholm", label: "timezone_se_stockholm" }
  ],
  "CH": [
    { value: "Europe/Zurich", label: "timezone_ch_zurich" }
  ],
  "PL": [
    { value: "Europe/Warsaw", label: "timezone_pl_warsaw" }
  ],
  "BE": [
    { value: "Europe/Brussels", label: "timezone_be_brussels" }
  ],
  "AT": [
    { value: "Europe/Vienna", label: "timezone_at_vienna" }
  ],
  "GR": [
    { value: "Europe/Athens", label: "timezone_gr_athens" }
  ],
  "PT": [
    { value: "Europe/Lisbon", label: "timezone_pt_lisbon" },
    { value: "Atlantic/Azores", label: "timezone_pt_azores" },
    { value: "Atlantic/Madeira", label: "timezone_pt_madeira" }
  ],
  "IE": [
    { value: "Europe/Dublin", label: "timezone_ie_dublin" }
  ],
  "FI": [
    { value: "Europe/Helsinki", label: "timezone_fi_helsinki" }
  ],
  "NO": [
    { value: "Europe/Oslo", label: "timezone_no_oslo" }
  ],
  "DK": [
    { value: "Europe/Copenhagen", label: "timezone_dk_copenhagen" }
  ],
  "CZ": [
    { value: "Europe/Prague", label: "timezone_cz_prague" }
  ],
  "HU": [
    { value: "Europe/Budapest", label: "timezone_hu_budapest" }
  ],
  "IL": [
    { value: "Asia/Jerusalem", label: "timezone_il_jerusalem" }
  ],
  "SG": [
    { value: "Asia/Singapore", label: "timezone_sg_singapore" }
  ],
  "NZ": [
    { value: "Pacific/Auckland", label: "timezone_nz_auckland" },
    { value: "Pacific/Chatham", label: "timezone_nz_chatham" }
  ],
  "TH": [
    { value: "Asia/Bangkok", label: "timezone_th_bangkok" }
  ],
  "MY": [
    { value: "Asia/Kuala_Lumpur", label: "timezone_my_kuala_lumpur" }
  ],
  "VN": [
    { value: "Asia/Ho_Chi_Minh", label: "timezone_vn_ho_chi_minh" }
  ],
  "PH": [
    { value: "Asia/Manila", label: "timezone_ph_manila" }
  ],
  "PK": [
    { value: "Asia/Karachi", label: "timezone_pk_karachi" }
  ]
};

export const industryOptions = [
    { value: "technology", label: "industry_technology" },
    { value: "healthcare", label: "industry_healthcare" },
    { value: "finance", label: "industry_finance" },
    { value: "education", label: "industry_education" },
    { value: "manufacturing", label: "industry_manufacturing" },
    { value: "retail", label: "industry_retail" },
    { value: "construction", label: "industry_construction" },
    { value: "transportation", label: "industry_transportation" },
    { value: "real_estate", label: "industry_real_estate" },
    { value: "energy", label: "industry_energy" },
    { value: "media", label: "industry_media" },
    { value: "telecom", label: "industry_telecom" },
    { value: "hospitality", label: "industry_hospitality" },
    { value: "agriculture", label: "industry_agriculture" },
    { value: "legal", label: "industry_legal" },
    { value: "government", label: "industry_government" },
    { value: "non_profit", label: "industry_non_profit" },
    { value: "other", label: "industry_other" }
];

export const languageOptions = [
    { value: "en", label: "language_en" },
    { value: "ar", label: "language_ar" },
    { value: "es", label: "language_es" },
    { value: "fr", label: "language_fr" },
    { value: "de", label: "language_de" },
    { value: "zh", label: "language_zh" },
    { value: "ja", label: "language_ja" },
    { value: "ru", label: "language_ru" },
    { value: "pt", label: "language_pt" },
    { value: "it", label: "language_it" },
    { value: "hi", label: "language_hi" }
];